import { render, staticRenderFns } from "./PointSecuritymoneyCancel.vue?vue&type=template&id=e068e5c2"
import script from "./PointSecuritymoneyCancel.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoneyCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports